<template>
  <section class="invoice-preview-wrapper">

    <b-row
      v-if="planningOrder"
      class="invoice-preview"
    >

      <!-- Col: Left (Invoice Container) -->
      <b-col
        cols="12"
        xl="9"
        md="8"
      >
        <b-card
          no-body
          class="invoice-preview-card"
        >
          <!-- Header -->
          <b-card-body class="invoice-padding pb-0">

            <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">

              <!-- Header: Left Content -->
              <div>
                <div class="logo-wrapper">
                  <img
                      height="40"
                      src="@/assets/images/logo/logo.png"
                  >
                  <h3 class="text-primary invoice-logo">
                    goaligner
                  </h3>
                </div>
                <p class="card-text mb-25">
                  Office 149, 450 South Brand Brooklyn
                </p>
                <p class="card-text mb-25">
                  Bucaramanga, Santander
                </p>
                <p class="card-text mb-0">
                  +57 315 6379093
                </p>
              </div>

              <!-- Header: Right Content -->
              <div class="mt-md-0 mt-2">
                <h4 class="invoice-title">
                  Id
                  <span class="invoice-number">#{{ planningOrder.order.planning_number }}</span>
                </h4>
                <div class="invoice-date-wrapper">
                  <p class="invoice-date-title">
                    Fecha de creación:
                  </p>
                  <p class="invoice-date">
                    {{ planningOrder.created_at }}
                  </p>
                </div>
                <div class="invoice-date-wrapper">
                  <p class="invoice-date-title">
                    Fecha de entrega:
                  </p>
                  <p class="invoice-date">
                    {{ planningOrder.order.delivery_date }}
                  </p>
                </div>
              </div>
            </div>
          </b-card-body>

          <!-- Spacer -->
          <hr class="invoice-spacing">

          <b-card-body
            v-if="planningOrder.order.clinic"
            class="invoice-padding pt-0"
          >
            <b-row class="invoice-spacing">

              <!-- Col: Invoice To -->
              <b-col
                cols="12"
                xl="6"
                class="p-0"
              >
                <h6 class="mb-2">
                  Entrega:
                </h6>
                <h6 class="mb-25">
                  {{ planningOrder.order.clinic.user.first_name }}
                </h6>
                <p class="card-text mb-25">
                  {{ planningOrder.order.clinic.user.last_name }}
                </p>
                <p class="card-text mb-25">
                  {{ planningOrder.order.clinic.address }}, {{ planningOrder.order.clinic.city.name }}
                </p>
                <p class="card-text mb-0">
                  {{ planningOrder.order.clinic.whatsapp }}
                </p>
                <p class="card-text mb-0">
                  <b>Odontólogo:</b> {{ planningOrder.order.dentist.full_name }}
                </p>
                <p class="card-text mb-0">
                  <b>Paciente:</b> {{ planningOrder.order.patient.full_name }}
                </p>
              </b-col>

              <!-- Col: Payment Details -->
<!--              <b-col
                xl="6"
                cols="12"
                class="p-0 mt-xl-0 mt-2 d-flex justify-content-xl-end"
              >
                <div>
                  <h6 class="mb-2">
                    Payment Details:
                  </h6>
                  <table>
                    <tbody>
                      <tr>
                        <td class="pr-1">
                          Total Due:
                        </td>
                        <td><span class="font-weight-bold">{{ paymentDetails.totalDue }}</span></td>
                      </tr>
                      <tr>
                        <td class="pr-1">
                          Bank name:
                        </td>
                        <td>{{ paymentDetails.bankName }}</td>
                      </tr>
                      <tr>
                        <td class="pr-1">
                          Country:
                        </td>
                        <td>{{ paymentDetails.country }}</td>
                      </tr>
                      <tr>
                        <td class="pr-1">
                          IBAN:
                        </td>
                        <td>{{ paymentDetails.iban }}</td>
                      </tr>
                      <tr>
                        <td class="pr-1">
                          SWIFT code:
                        </td>
                        <td>{{ paymentDetails.swiftCode }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-col>-->
            </b-row>
          </b-card-body>

          <!-- Invoice Description: Table -->
          <b-table-lite
            responsive
            :items="dataItems"
            :fields="['Producto', 'Cantidad']"
          >
            <template #cell(dataItems)="data">
              <b-card-text class="font-weight-bold mb-25">
                {{ data.item.Producto }}
              </b-card-text>
              <b-card-text class="text-nowrap">
                {{ data.item.Cantidad }}
              </b-card-text>
            </template>
          </b-table-lite>

          <!-- Invoice Description: Total -->
          <b-card-body class="invoice-padding pb-0">
            <b-row>

              <!-- Col: Sales Persion -->
              <b-col
                cols="12"
                md="6"
                class="mt-md-0 mt-3"
                order="2"
                order-md="1"
              >
                <b-card-text class="mb-0">
                  <span class="font-weight-bold">Fecha de aprobación:</span>
                  <span class="ml-75">{{ planningOrder.approval_date }}</span>
                </b-card-text>
                <b-card-text class="mb-0">
                  <span class="font-weight-bold">Tipo de trabajo:</span>
                  <span class="ml-75">{{ planningOrder.manufacturing.work_type.name }}</span>
                </b-card-text>
              </b-col>

              <!-- Col: Total -->
<!--              <b-col
                cols="12"
                md="6"
                class="mt-md-6 d-flex justify-content-end"
                order="1"
                order-md="2"
              >
                <div class="invoice-total-wrapper">
                  <div class="invoice-total-item">
                    <p class="invoice-total-title">
                      Alineadores superiores:
                    </p>
                    <p class="invoice-total-amount">
                      {{ planningOrder.manufacturing.upper_aligners }}
                    </p>
                  </div>
                  <div class="invoice-total-item">
                    <p class="invoice-total-title">
                      Alineadores inferiores:
                    </p>
                    <p class="invoice-total-amount">
                      {{ planningOrder.manufacturing.lower_aligners }}
                    </p>
                  </div>

                </div>
              </b-col>-->
            </b-row>
          </b-card-body>

          <!-- Spacer -->
          <hr class="invoice-spacing">

          <!-- Note -->
          <b-card-body class="invoice-padding pt-0">
            <span class="font-weight-bold">Note: </span>
            <span>Fue un placer trabajar contigo y tu equipo. Esperamos que nos tengas en cuenta para futuros proyectos. ¡Gracias!</span>
          </b-card-body>
        </b-card>
      </b-col>

      <!-- Right Col: Card -->
      <b-col
        cols="12"
        md="4"
        xl="3"
        class="invoice-actions"
      >
        <b-card>

          <!-- Button: Send Invoice -->
<!--          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            v-b-toggle.sidebar-send-invoice
            variant="primary"
            class="mb-75"
            block
          >
            Send Invoice
          </b-button>-->

          <!-- Button: Print -->
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            class="mb-75"
            block
            @click="printInvoice"
          >
            Imprimir
          </b-button>

        </b-card>
      </b-col>
    </b-row>

  </section>
</template>

<script>
import { ref, onUnmounted } from '@vue/composition-api'
import store from '@/store'
import router from '@/router'
import {
  BRow, BCol, BCard, BCardBody, BTableLite, BCardText, BButton, BAlert, BLink, VBToggle,
} from 'bootstrap-vue'
import Logo from '@core/layouts/components/Logo.vue'
import Ripple from 'vue-ripple-directive'
import api from '@/plugin/axios'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BTableLite,
    BCardText,
    BButton,
    BAlert,
    BLink,

    Logo,
  },
  data() {
    return {
      planningOrder: null,
      dataItems: null,
    }
  },
  setup() {
    const printInvoice = () => {
      window.print()
    }

    return {
      printInvoice,
    }
  },
  async created() {
    const [response] = await Promise.all([
      api.get(`/api/planning-orders/${this.$route.params.id}`),
    ])

    this.planningOrder = response.data

    this.dataItems = [
      {
        Producto: 'Alineadores superiores',
        Cantidad: this.planningOrder.manufacturing.upper_aligners,
      },
      {
        Producto: 'Alineadores inferiores',
        Cantidad: this.planningOrder.manufacturing.lower_aligners,
      },
    ]

    console.log(this.planningOrder)
  },
}
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
</style>

<style lang="scss">
@media print {

  // Global Styles
  body {
    background-color: transparent !important;
  }
  nav.header-navbar {
    display: none;
  }
  .main-menu {
    display: none;
  }
  .header-navbar-shadow {
    display: none !important;
  }
  .content.app-content {
    margin-left: 0;
    padding-top: 2rem !important;
  }
  footer.footer {
    display: none;
  }
  .card {
    background-color: transparent;
    box-shadow: none;
  }
  .customizer-toggle {
    display: none !important;
  }

  // Invoice Specific Styles
  .invoice-preview-wrapper {
    .row.invoice-preview {
      .col-md-8 {
        max-width: 100%;
        flex-grow: 1;
      }

      .invoice-preview-card {
        .card-body:nth-of-type(2) {
          .row {
              > .col-12 {
              max-width: 50% !important;
            }

            .col-12:nth-child(2) {
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              margin-top: 0 !important;
            }
          }
        }
      }
    }

    // Action Right Col
    .invoice-actions {
      display: none;
    }
  }
}
</style>
